import Image from "next/legacy/image"
import useStore from "components/ui/Context"
import { useState } from "react"
import { renderTimeFromNow, renderTime, convertSecondToTimePlay } from "utils/time"
import Link from "next/link"
import Tippy from "@tippyjs/react"
import IconStar from "assets/icon/iconStar"

function CardVertical({
  is_live,
  name,
  category_name,
  start_time,
  status,
  duration,
  thumbnail,
  thumbnail_vertical,
  created,
  hideText,
  showTime = true,
  id,
  type_name,
  league_sync_id,
  type,
  icon,
  is_monopoly = false,
  is_premium = false,
  nextLink
}) {
  const setModalLive = useStore().setModalLive
  const [srcImage, setSrcImage] = useState(league_sync_id ? thumbnail : thumbnail_vertical)

  function nextPath() {
    if (status !== "live" && is_live) {
      setModalLive({
        show: true,
        isVod: true,
        info: {
          title: name,
          start_time
        }
      })
    }
  }
  return (
    <div onClick={nextPath} className="flex flex-col gap-3 rounded-xl">
      {/* card tỉ lệ 2/3 */}
      <div className="relative wapper__play">
        <Link href={nextLink}>
          <div className="fix_img">
            <Image
              className="rounded-xl"
              src={srcImage}
              width={2000}
              height={3000}
              alt={name}
              onError={() => setSrcImage("/placeholder_video_vertical.svg")}
            />
          </div>
          {is_premium && (
            <div className="flex items-center gap-1 absolute top-3 left-0 bg-[linear-gradient(to_right,#FF4D00,#F67A36)] py-1 px-2">
              <IconStar />
              <span className="text-[#FFEB99] text-xs font-bold">Premium</span>
            </div>
          )}
          {!league_sync_id && (
            <div className="layer__play rounded-xl">
              <div className="icon__play">
                <div className="icon__play">
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http:www.w3.org/2000/svg">
                    <path
                      d="M7.30078 7.65618C7.30078 5.43726 9.6747 4.02636 11.6238 5.08689L27.6938 13.8309C29.7298 14.9387 29.7298 17.8616 27.6938 18.9695L11.6238 27.7135C9.6747 28.774 7.30078 27.3631 7.30078 25.1442V7.65618Z"
                      fill="#FAFAF9"
                    />
                  </svg>
                </div>
              </div>
            </div>
          )}
          {/* {is_monopoly && (
           <div className="absolute top-0 right-0">
             <img src={"/icon/iconExclusive.svg"} className="rounded-tr-xl" width={50} height={32} alt={name} />
           </div>
         )} */}
        </Link>
        {status === "live" && is_live && (
          <div className="absolute shadow top-2 left-2 bg-primary-medium rounded-xl flex items-center px-1 ">
            <div className=" rounded-full h-2 w-2 bg-red-500 mr-1"></div>
            <div className="text-primary-dark font-semibold" style={{ fontSize: 10 }}>
              LIVE
            </div>
          </div>
        )}
        {!is_live && !league_sync_id && (
          <div className="font-medium py-0.5 px-2 absolute text-xs min-[1440px]:text-sm bottom-2 right-2 bg-[#13131385] rounded-lg">
            <div>{convertSecondToTimePlay(duration)}</div>
          </div>
        )}
      </div>
      <Link href={nextLink}>
        <div className="flex flex-col cursor-pointer font-normal gap-1">
          <Tippy content={name}>
            <div className="line-clamp-2 w-full text-sm min-[1440px]:text-base text-[#FAFAF9]">{name}</div>
          </Tippy>
        </div>
      </Link>

      {showTime && (
        <time dateTime={new Date(start_time)} className="text-primary-dark text-xs">
          {is_live ? renderTime(start_time) : renderTimeFromNow(created)}
        </time>
      )}
    </div>
  )
}
export default CardVertical
